













import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { needSmoothCheck, vote } from '@/api/api.ts';
import SlideVerify from '@/components/SlideVerify.vue';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
@Component({
  components: {
    SlideVerify,
  },
})
export default class VoteButton extends Vue {
  @Prop() mustApp!: boolean;
  @Prop() voteName!: string;
  @Prop() voteId!: string | number;
  @Prop() voteWeChat!: boolean;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  SlideShow = false;
  pointOut = false;
  unionId!: string | null;
  startVote() {
    // 开始投票，判断是不是必须在app内投票
    if (this.voteWeChat && isWeiXin()) {
      console.log('weixin');
      this.unionId = window.localStorage.getItem('unionid');
      const data = {
        id: this.voteId,
        unionid: this.unionId,
      };
      vote(this.voteName, data).then((result: any) => this.successVote(result));
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请分享到微信端参与点赞投票!',
        confirmButtonText: '确定',
        closeOnClickOverlay: true,
      });
    }
  }
  fSlideData(res: object) {
    this.SlideShow = false;
    if (this.voteWeChat && isWeiXin()) {
      const data = {
        id: this.voteId,
        unionid: this.unionId,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请分享到微信端参与点赞投票!',
        confirmButtonText: '确定',
        closeOnClickOverlay: true,
      });
    }
  }
  successVote(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 3000,
          message: res.msg,
        });
        this.$emit('votSuccess', res.data);
        break;
      case 201:
        this.SlideShow = true;
        break;
      case 202:
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        break;
      case 500:
        Toast.fail(res.msg);
        break;
      case 203:
        if (this.voteWeChat && isWeiXin()) {
          Toast({
          duration: 3000,
          message: res.msg,
        });
        }
        break;
      case 300:
        Toast.fail(res.msg);
        break;
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
}
